import React from 'react'
import _ from 'underscore'
import { Button } from '@/components/ui/button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import Checkbox from '../checkbox'
import Modal from '../modal'
import JobReadiness from '../enquiry/lesson_plans/job_readiness'
import RequestPlacementPosition from './position'
import store from '../../state/store'

// Radix reserves value="" for "no selection", so the unassigned option is
// mapped to this sentinel and translated back to '' in onSelectManager.
const UNASSIGNED = '__unassigned'

class RequestPlacement extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      accepted_position_ids: []
    }
  }

  onProceed = () => {
    store.emit('tutoring_jobs:request_placement')
  }

  onToggleSearch = () => {
    store.emit('ui:request_placement:toggle_search', !this.props.ui.request_placement.request_tutor_search)
  }

  onClose = () => {
    store.emit('ui:request_placement:close')
  }

  onSelectManager = (value) => {
    store.emit('ui:request_placement:select_manager', value === UNASSIGNED ? '' : value)
  }

  render() {
    const { placement_managers, placement_manager_id } = this.props.ui.request_placement

    return (
      <Modal title="Send to Tutor Placement" subtitle="The client will be informed that placement has started." size="modal-lg" onClose={this.onClose}>
        <div className="grid gap-6 p-6 text-left">
          {this.props.lesson_plan &&
            <JobReadiness lesson_plan={this.props.lesson_plan} />
          }
          <div className="grid gap-2">
            <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Tutor Search</h4>
            <Checkbox name='Start Tutor Search' value="request_tutor_search" checked={this.props.ui.request_placement.request_tutor_search} onChange={this.onToggleSearch} label_weight={"normal"} />
          </div>
          <div className="grid gap-2">
            <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Find tutors for these subjects</h4>
            <div className="grid gap-1">
              {_.map(this.props.tutoring_job.tutoring_job_positions, (position) => {
                const selected = this.props.ui.request_placement.position_ids.includes(position.id)

                return (
                  <RequestPlacementPosition
                    key={position.id}
                    tutoring_job_position={position}
                    selected={selected}
                  />
                )
              })}
            </div>
          </div>
          <div className="grid gap-2">
            <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Assign to</h4>
            <Select
              value={placement_manager_id ? `${placement_manager_id}` : UNASSIGNED}
              onValueChange={this.onSelectManager}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select a staff member…"/>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value={UNASSIGNED}>Unassigned</SelectItem>
                {_.map(placement_managers, (manager) => (
                  <SelectItem key={manager.id} value={`${manager.id}`}>
                    {manager.name} — {manager.active_request_count} active
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" size="sm" onClick={this.onClose}>Cancel</Button>
            <Button variant="success" size="sm" onClick={this.onProceed}>Send to Placement</Button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default RequestPlacement
